import { render, staticRenderFns } from "./Reciep.vue?vue&type=template&id=329d1cca&scoped=true"
import script from "./Reciep.vue?vue&type=script&lang=js"
export * from "./Reciep.vue?vue&type=script&lang=js"
import style0 from "./Reciep.vue?vue&type=style&index=0&id=329d1cca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "329d1cca",
  null
  
)

export default component.exports